let _serverUrl: Nullable<string> = null
let _jwtToken: Nullable<string> = null

function setAsclepiusServerUrl(url: string) {
    if (_serverUrl != null)
        throw Error("Asclepius config has already been initialized, it can only be inited once!")

    _serverUrl = url
}

function getAsclepiusServerUrl(): string {
    if (_serverUrl === null)
        throw Error("Asclepius server url has not yet been set, call `setAsclepiusServerUrl` first!")

    return _serverUrl
}

function setJwtToken(jwtToken: string) {
    _jwtToken = jwtToken
}

function clearJwtToken() {
    _jwtToken = null
}

function getJwtToken(): Nullable<string> {
    return _jwtToken
}

export default {
    setAsclepiusServerUrl,
    getAsclepiusServerUrl,
    setJwtToken,
    getJwtToken,
    clearJwtToken
}